import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./shared/Footer";
import styled from "styled-components";

const RootLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LayoutWrapper>
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </LayoutWrapper>
  );
};

export default RootLayout;

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1;
`;
